export const environments = {
  DEVELOPMENT: 'development',
  STAGING: 'staging',
  PRODUCTION: 'production',
}

export const getEnvironment = (ctx) => {
  const host = getHost(ctx)
  if (isStaging(host)) {
    return environments.STAGING
  }

  if (isDevelopment(host)) {
    return environments.DEVELOPMENT
  }

  return environments.PRODUCTION
}

const getHost = (ctx) => {
  const req = ctx.req
  if (process.browser) {
    return window.location.host
  }

  return req.headers.host
}

const isStaging = (host) => {
  return host && host.includes('staging')
}

const isDevelopment = (host) => {
  return host && (host.includes('dev') || host.includes('0.0.0.0') || host.includes('localhost'))
}
